import ProgressBarExtrasDrawerContainer from './ProgressBarExtrasDrawerContainer';

export default ProgressBarExtrasDrawerContainer;
